<template>
    <div class="innerBox mt-3">
        <div class="row pl-4 mt-2 mb-3">
			<div class="col-md-12 text-left" style="margin-top:auto;margin-bottom:auto;">
				<h6>Daftar Barang Part Untuk Work Order</h6>
			</div>

            <!-- {{estimatorSparepartData}} -->
            <div class="pl-2 pr-2 w-100">
                <table class="table table-border mt-3">
                    <thead>
                        <th>No.</th>
                        <!-- <th>Tipe Sparepart</th> -->
                        <th>Nama Jasa / Part</th>
                        <th>Part Description</th>
                        <th>Jumlah Diperlukan</th>
                        <!-- <th></th> -->
                        <th colspan="3"><i class="fas fa-cog"></i></th>
                    </thead>
                    <tbody>
                        <tr v-if="estimatorSparepartData.length == 0">
                            <td colspan="10" class="text-center"><h5>Tidak ada part yang diajukan untuk Work Order Tersebut</h5></td>
                        </tr>
                        <!-- {{estimatorSparepartData}} -->
                        <template v-for="(estimationPart , index) in estimatorSparepartData">
                            <tr  :key="index" v-if="estimationPart.is_arrived">
                                <td>
                                    {{index + 1}}
                                    <!-- {{estimationPart}} -->
                                </td>
                                <!-- <td>
                                    {{estimationPart.sparepart_type}}
                                </td> -->
                                <td>
                                    {{estimationPart.sparepart_name}}
                                </td>
                                <td>
                                    {{estimationPart.part_number ? estimationPart.part_number : '-'}}
                                </td>
                                <td>{{estimationPart.amount}}</td>
                                
                                <td>
                                    <b class="text-green" v-if="estimationPart.is_used">
                                        Terpakai {{usageList.find(x => x.spare_part_id == estimationPart.sparepart_id && x.labourer_id) ?
                                        `( ${usageList.find(x => x.spare_part_id == estimationPart.sparepart_id && x.labourer_id).labourer.name} )` : '' }}
                                    </b>
                                    <button type="button" class="btn btn-primary" v-else-if="estimationPart.is_arrived" @click="useInventory(estimationPart.ppn_included ,estimationPart.id , estimationPart.sparepart_id, estimationPart.amount, estimationPart.sparepart_name , parseFloat(estimationPart.price_per_item) + parseFloat(estimationPart.markup ? estimationPart.markup : 0))">Konfimarsi Pengambilan</button>
                                    <b class="text-yellow" v-else-if="estimationPart.is_po">Sudah PO</b>
                                    <button type="button" class="btn btn-danger" v-else-if="estimationPart.stock < estimationPart.amount" @click="POBarang(estimationPart.id , estimationPart.sparepart_id)">PO Barang</button>

                                </td>
                                <td >
                                    <!-- {{usageList.find(x => x.spare_part_id == estimationPart.sparepart_id)}} -->
                                    <!-- {{estimationPart}} -->
                                    <button :disabled="!estimationPart.is_used" class="btn btn-outline-info" type="button" name="Liat Tanda Tangan Pekerja" @click="selectImage = usageList.find(x => x.spare_part_id == estimationPart.sparepart_id && x.sign_pic).sign_pic;labor_name = usageList.find(x => x.spare_part_id == estimationPart.sparepart_id && x.labourer_id).labourer.name"><i class="fa fa-signature"></i></button>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
		</div>

        <preview-image
			v-if="selectImage"
			@closeModal="selectImage = null"
			:title="'Bukti Pengambilan ' + labor_name"
			:image="env.baseImage + '/' + selectImage"
		></preview-image>

        <ttdModal 
			v-if="showTtdModal"
			@closeModal="showTtdModal = false"
			@submit="submitSignature"
		/>
    </div>
</template>

<script>
import previewImage from '@/components/modal/previewImage'
import env from '@/env'
import ttdModal from './ttdModal.vue'
import moment from 'moment'

export default {
    components : {
        previewImage,
        ttdModal
    },
    data () {
        return {
            env,
            selectImage : null,
            showTtdModal : false,
            ttdImage : null,
            temp : {},
            labourer : null,
            options : this.$store.getters.getFilterOptions
        }
    },
    props : ['estimatorSparepartData' , 'usageList', 'workOrderCode'],
    // mounted ()
    methods : {
        submitSignature(img , labourer) {
			this.ttdImage = img
            this.labourer = labourer
            this.showTtdModal = false
            
			this.useInventory(this.temp.ppn_included, this.temp.id , this.temp.sparepart_id , this.temp.amount , this.temp.name , this.temp.price_per_item)
		},
        useInventory (ppn_included, id , sparepart_id , amount, name , price_per_item) {

			if(!this.ttdImage) {
				this.temp.id = id
				this.temp.sparepart_id = sparepart_id
				this.temp.amount = amount
				this.temp.name = name
				this.showTtdModal = true
				this.temp.price_per_item = price_per_item
				this.temp.ppn_included = ppn_included
				return;
			}

			let data = {
				estimation_id : id,
				is_used : true,
				is_used_date : new moment().format('Y-MM-DD')
			}


			this.$http.patch('/api/v1/purchase-order/' + this.workOrderCode , data)
			.then((resp) => {
				// insert pricenya
				console.log(data)
				let price = price_per_item ? price_per_item * amount : 0
				let dataInventory = {
					sparepart_id : sparepart_id , 
					price_per_item : price_per_item ? price_per_item : 0,
					labourer_id : this.labourer,
					amount : amount * -1,
					// transaction_type_id 
					workorder_code : this.workOrderCode,
					transaction_description : `Pengunaan Sparepart ${name} Oleh ${this.labourer.name}`,
					sign_pic : this.ttdImage,
					status : 'is_used',
					accountTransaction : [{
						type : 'Accounts Payable',
						amount : price,
						debit_credit : 1,
						description : `PUtang Pembayaran Sparepart ${name} Kepada Supplier`
					}],
				}

				this.$http.post('/api/v1/inventory' , dataInventory)
				.then((resp) => {
					this.$store.dispatch('triggerAlert' , [true , 'Pengunaan Sparepart Behasil Tercatat'])
					// this.getEstimationDetails()
					// this.getInventoryUsageWO()
                    // this.$emit('doneSparepart')
                    this.$emit('reloadTable')
				})
				.catch((err) =>{
					console.log(err)
					this.$store.dispatch('triggerAlert' , [ false , 'Ada Terjadi Kendala. Mohon Dicoba Berberapa Saat Lagi.'])
				})


			})
			.catch((err)=> {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [ false , 'Ada Terjadi Kendala. Mohon Dicoba Berberapa Saat Lagi.'])
			})
			
		},
    }
}
</script>